import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { useBreakpoints } from '../theme/useBreakpoints';
import { ArrowRightIcon } from '../theme/Icons';

export const ManageButton: React.FC<{careMapId: string}> = ({ careMapId }) => {
    const history = useInstance(HistoryViewModel);
    const { isAboveBreakpoint } = useBreakpoints();
    return (
        <IonButton
            fill="clear"
            color="primary"
            data-id="community-management-button"
            onClick={() => history.push(`/community/${careMapId}`)}
        >
            {isAboveBreakpoint('sm') ? 'Manage Community' : 'Manage'}&nbsp;<ArrowRightIcon />
        </IonButton>
    );
};
